/**
 * @generated SignedSource<<72a9a4ca06770ccf25e83a2cd75a1c82>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleRenderArticle$data = {
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"articleActionWidgetArticle" | "articleAdditionalInfoBoxArticleContent" | "articleAuthorBlockArticle" | "articleAuthorDetailsContent" | "articleBaseAdvertisingInfoArticle" | "articleCommentsTriggerArticle" | "articleCorrectionsWidgetArticle" | "articleImageGalleryContent" | "articleLeadingArticle" | "articleLeftHandSideWidgetsContent" | "articleMoreOnThisListArticle" | "articlePaywallContainerArticle" | "articlePrintHeadlineMessageArticle" | "articleReactionArticle" | "articleSectionsContent" | "articleShareWidgetArticle" | "articleSpeechInlineWidgetArticle" | "articleSpeechPlayerPortalArticle" | "articleSponsorContent" | "articleTopicFollowWidgetArticle" | "articleTopicsContent" | "articleTypeformArticle" | "articleUtilsArticle" | "articleVocabBoxArticle" | "contentBodyContent" | "contentHeadlineContent" | "contentLiveTagContent" | "contentReadMoreButtonContent" | "contentSchemaRenderContent" | "contentSubHeadlineContent" | "contentSummaryContent" | "genericArticleArticle" | "globalCheckerContent" | "helpersCheckIsPlusArticle" | "helpersCheckIsPostiesArticle" | "helpersCheckIsStyleArticle" | "hooksPostiesArticleArticle" | "infographicArticleArticle" | "liveArticleArticle" | "longReadArticleArticle" | "morningStudioArticleContent" | "newsletterArticleArticle" | "opinionArticleContent" | "photoEssayArticleArticle" | "pianoIntegrationArticle" | "plusColumnsArticleContent" | "plusGenericArticleContent" | "seriesArticleArticle" | "styleArticleContent">;
  readonly " $fragmentType": "articleRenderArticle";
};
export type articleRenderArticle$key = {
  readonly " $data"?: articleRenderArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleRenderArticle">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = [
  {
    "kind": "Variable",
    "name": "customContents",
    "variableName": "customContents"
  }
],
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SectionSegment",
    "kind": "LinkedField",
    "name": "sections",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "value",
        "plural": true,
        "selections": (v1/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "customContents"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleRenderArticle",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleActionWidgetArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleAdditionalInfoBoxArticleContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleAuthorBlockArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleAuthorDetailsContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleBaseAdvertisingInfoArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleCommentsTriggerArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleCorrectionsWidgetArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleImageGalleryContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleLeadingArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleLeftHandSideWidgetsContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleMoreOnThisListArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articlePaywallContainerArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articlePrintHeadlineMessageArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleReactionArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleSectionsContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleShareWidgetArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleSpeechInlineWidgetArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleSpeechPlayerPortalArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleSponsorContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleTopicFollowWidgetArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleTopicsContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleTypeformArticle"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "articleUtilsArticle",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleTypeSegment",
          "kind": "LinkedField",
          "name": "types",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ArticleType",
              "kind": "LinkedField",
              "name": "value",
              "plural": true,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleVocabBoxArticle"
    },
    {
      "args": (v2/*: any*/),
      "kind": "FragmentSpread",
      "name": "contentBodyContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentHeadlineContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentLiveTagContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentReadMoreButtonContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSchemaRenderContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSubHeadlineContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSummaryContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "genericArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "globalCheckerContent"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersCheckIsPlusArticle",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PaywallType",
          "kind": "LinkedField",
          "name": "paywallTypes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityUuid",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersCheckIsPostiesArticle",
      "selections": (v3/*: any*/),
      "args": null,
      "argumentDefinitions": []
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersCheckIsStyleArticle",
      "selections": (v3/*: any*/),
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": (v2/*: any*/),
      "kind": "FragmentSpread",
      "name": "hooksPostiesArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "infographicArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "liveArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "longReadArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "morningStudioArticleContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "newsletterArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "opinionArticleContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "photoEssayArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "pianoIntegrationArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "plusGenericArticleContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "plusColumnsArticleContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "styleArticleContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "seriesArticleArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "9c20c48958ded49593ad4c38f9282696";

export default node;
